// @flow
import { switchClientDropdownActions } from './switchClientDropdownActionCreator';

const initialState = {
  isSwitchClientVisible: false,
  selectedClient: null
};

const switchClientDropdownReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case switchClientDropdownActions.TOGGLE_SWITCH_CLIENT_DROPDOWN: {
      return Object.assign({}, state, {
        isSwitchClientVisible: action.payload
      });
    }
    case switchClientDropdownActions.SELECTED_CLIENT: {
      return Object.assign({}, state, {
        selectedClient: action.payload
      });
    }
    default: {
      return state;
    }
  }
};

export default switchClientDropdownReducer;
